import {
  normalizeDecimalInput,
  roundToDecimal,
} from "@/lib/utils/format-decimal";

export const preprocessRequiredInt = (val: unknown): number | undefined => {
  if (val === "" || val === null || val === undefined) return undefined;
  if (typeof val === "string") {
    const parsed = parseInt(val, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
  }
  return typeof val === "number" ? val : undefined;
};

export const preprocessRequiredNumber = (val: unknown): number | undefined => {
  if (val === "" || val === null || val === undefined) return undefined;
  if (typeof val === "string") {
    const parsed = parseFloat(String(normalizeDecimalInput(val)));
    return Number.isNaN(parsed) ? undefined : parsed;
  }
  return typeof val === "number" ? val : undefined;
};

/** Parses a required decimal (precision 2). Empty values stay undefined. */
export const preprocessRequiredDecimal = (val: unknown): number | undefined => {
  const parsed = preprocessRequiredNumber(val);
  if (parsed === undefined) return undefined;
  return roundToDecimal(parsed);
};

export const preprocessIntWithDefault = (val: unknown): number => {
  if (val === "" || val === null || val === undefined) return 0;
  if (typeof val === "string") {
    const parsed = parseInt(val, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return typeof val === "number" ? val : 0;
};

export const preprocessNumberWithDefault = (val: unknown): number => {
  if (val === "" || val === null || val === undefined) return 0;
  if (typeof val === "string") {
    const parsed = parseFloat(String(normalizeDecimalInput(val)));
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return typeof val === "number" ? val : 0;
};
